import { useCallback, useContext } from 'react'
import { TechnicalPrimaryContext } from '../../TechnicalPrimary/TechnicalPrimaryContext'

/**
 * Whether a system user is a Technical Primary, and a toggle for the role. `isAvailable` is false while
 * the Technical Primary feature is off for the organization.
 */
const useTechnicalPrimaryRole = (userId) => {
  const technicalPrimary = useContext(TechnicalPrimaryContext)
  const isTechnicalPrimary = !!technicalPrimary?.contacts?.assignments.some(
    (assignment) => assignment.user_id === userId,
  )

  const toggleRole = useCallback(() => {
    if (isTechnicalPrimary) technicalPrimary.remove(userId)
    else technicalPrimary.assign(userId)
  }, [isTechnicalPrimary, technicalPrimary, userId])

  return {
    isAvailable: !!technicalPrimary,
    isTechnicalPrimary,
    isSaving: !!technicalPrimary?.isSaving || !technicalPrimary?.contacts,
    toggleRole,
  }
}

export default useTechnicalPrimaryRole
